import React, { useCallback, useEffect, useRef, useState } from 'react'
import CMS from '../CMS/CMS'
import { Accordion } from 'react-bootstrap'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import Swal from 'sweetalert2'
import requestApi from '../../utils/request'
import FAQAddEditModal from '../../components/FAQAddEditModal/FAQAddEditModal'
import { ReactComponent as IconPlus } from '../../assets/images/icons/icon-plus-white.svg'
import { ReactComponent as IconsDots } from '../../assets/images/icons/icon-action-dots.svg'
import { ReactComponent as IconEdit } from '../../assets/images/icons/icon-edit-white.svg'
import { ReactComponent as IconView } from '../../assets/images/icons/icon-view-white.svg'
import { ReactComponent as IconDelete } from '../../assets/images/icons/icon-delete-white.svg'
import FAQSkeleton from '../../components/FAQSkeleton/FAQSkeleton'
import Pagination from '../../components/Pagination'
import DeleteModal from '../../components/DeleteModal/DeleteModal'
import NoRecordFound from '../../components/NoRecordFound/NoRecordFound'

const FAQManagement = () => {
    const [openModal, setOpenModal] = useState(false)

    const queryClient = useQueryClient()
    const EditDataRef = useRef(null)

    const [isDeleteModal, setIsDeleteModal] = useState(false)
    const [deleteId, setDelteId] = useState('')
    const [updateId, setUpdateId] = useState('')
    const [DataLimit, setDataLimit] = useState(10)
    const [currentPage, setCurrentPage] = useState(1)
    const [searchKeyword, setSearchKeyword] = useState('')
    const [sorting, setSorting] = useState([])

    const handleModal = (id) => {
        setOpenModal(true)
        setUpdateId(id)
    }

    const [openAction, setopenAction] = useState(null)
    const OpenAction = (id) => {
        setopenAction(openAction === id ? null : id)
    }

    function FAQListing({ queryKey }) {
        return requestApi
            .post(
                `faq/list`,
                {
                    limit: queryKey[2],
                    page: queryKey[1]
                    //   search: queryKey[3],
                    //   sortKey: "",
                    //   sortBy: 1
                    // queryKey[4] ? (queryKey[4]?.desc ? -1 : 1) : '',
                },
                { headers: true }
            )
            .then((res) => {
                return res.data
            })
    }

    const { data: FAQData, isLoading } = useQuery({
        queryKey: [
            'faqlist',
            currentPage,
            DataLimit
            //   searchKeyword,
            // sorting[0],
        ],
        queryFn: FAQListing
    })

    const handleChangePage = useCallback(
        (currentPage) => {
            setCurrentPage(currentPage)
        },
        [currentPage]
    )

    useEffect(() => {
        if (currentPage && FAQData?.length == 0) {
            setCurrentPage(currentPage - 1)
        } else {
        }
    }, [currentPage, FAQData?.data])

    useEffect(() => {
        setCurrentPage(1)
    }, [searchKeyword])

    const handleDeleteModal = (id) => {
        setIsDeleteModal(true)
        setDelteId(id)
    }

    //#region delete FAQ
    function handleDelete(faqId) {
        mutationDelete.mutate(faqId)
        setIsDeleteModal(false)
    }

    async function deletefaqId(faqId) {
        return await requestApi.post(`/faq/delete`, {
            faqId
        })
    }
    const mutationDelete = useMutation(deletefaqId, {
        onSuccess: ({ data }) => {
            queryClient.invalidateQueries('faqlist')
            setIsDeleteModal(false)
            EditDataRef.current = null
        },
        onError: (error) => {
            EditDataRef.current = null
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                allowOutsideClick: false,
                text: error?.message
            })
        }
    })
    //#endregion

    return (
        <CMS>
            <div className="head faq-head">
                <h2>FAQs</h2>
                <button onClick={() => handleModal()} className="solid-red-btn">
                    <IconPlus />
                    Add FAQ
                </button>
            </div>
            <div className="support-body-content faq-body pb-0">
                {isLoading ? (
                    <FAQSkeleton />
                ) : FAQData?.data?.length == 0 ? (
                    <NoRecordFound />
                ) : (
                    <Accordion className="admin-accordion">
                        {FAQData?.data?.map((rr, i) => {
                            return (
                                <Accordion.Item
                                    eventKey={rr?.faqId}
                                    key={rr?.faqId}
                                >
                                    <div className="head">
                                        {rr?.question}
                                        <div className="accordion-action">
                                            <div
                                                className={`table-action ${
                                                    rr?.faqId === openAction
                                                        ? 'active'
                                                        : ''
                                                }`}
                                                onMouseLeave={() => setopenAction(null)}
                                            >
                                                <div
                                                    className={`action-btn ${
                                                        rr?.faqId === openAction
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        OpenAction(rr?.faqId)
                                                    }
                                                >
                                                    <IconsDots />
                                                </div>
                                                <div className="action-panel two-action">
                                                    <div
                                                        className="action-btn-icon edit"
                                                        onClick={() =>
                                                            handleModal(
                                                                rr?.faqId
                                                            )
                                                        }
                                                    >
                                                        <IconEdit />
                                                    </div>
                                                    <div
                                                        className="action-btn-icon delete"
                                                        onClick={() => {
                                                            handleDeleteModal(
                                                                rr?.faqId
                                                            )
                                                        }}
                                                    >
                                                        <IconDelete />
                                                    </div>
                                                </div>
                                            </div>
                                            <Accordion.Header></Accordion.Header>
                                        </div>
                                    </div>
                                    <Accordion.Body>
                                        <p>{rr?.answer}</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                            )
                        })}
                    </Accordion>
                )}
            </div>

            {isLoading ? (
                <FAQSkeleton cname="pagination-faqskeleton" />
            ) : (
                FAQData?.meta?.totalCount > 0 && (
                    <div className="pagination-wrap">
                        <div className="showing-pages">
                            <span>
                                Showing {(currentPage - 1) * DataLimit + 1} to{' '}
                                {Math.min(
                                    currentPage * DataLimit,
                                    FAQData?.meta?.totalCount
                                )}{' '}
                                of {FAQData?.meta?.totalCount} FAQs
                            </span>
                        </div>
                        {FAQData?.meta?.totalCount > 10 && (
                            <>
                                {/* <div className="itemperpage-box">
                                        <span>Items per page:</span>
      
                                        <Dropdown onSelect={handleChange}>
                                            <Dropdown.Toggle
                                                variant="success"
                                                id="dropdown-basic"
                                            >
                                                {DataLimit}
                                            </Dropdown.Toggle>
      
                                            <Dropdown.Menu>
                                                <Dropdown.Item eventKey="10">
                                                    10
                                                </Dropdown.Item>
                                                <Dropdown.Item eventKey="20">
                                                    20
                                                </Dropdown.Item>
                                                <Dropdown.Item eventKey="30">
                                                    30
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div> */}

                                <Pagination
                                    total={Math.ceil(
                                        FAQData?.meta?.totalCount / DataLimit
                                    )}
                                    current={currentPage}
                                    onChangePage={handleChangePage}
                                />
                            </>
                        )}
                    </div>
                )
            )}

            <FAQAddEditModal
                openModal={openModal}
                setOpenModal={setOpenModal}
                updateId={updateId}
                setUpdateId={setUpdateId}
            />

            <DeleteModal
                message={
                    <>
                        Are you sure you want to <br /> delete this FAQ ?
                    </>
                }
                setIsDeleteModal={setIsDeleteModal}
                isDeleteModal={isDeleteModal}
                handleDelete={() => handleDelete(deleteId)}
            />
        </CMS>
    )
}

export default FAQManagement
